import { Component, Renderer2, OnDestroy } from '@angular/core';
import { TitleBarComponent } from '../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: true,
    imports: [TitleBarComponent]
})
export class HomeComponent implements OnDestroy {
  public cellSpacing: number[] = [10, 10];

  constructor(private renderer: Renderer2) {
    this.renderer.addClass(document.body, 'body-home');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'body-home');
  }
}
